import { useContext, useEffect } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { UserContext } from "../../../contexts/UserContext";
import { boolean, object, setLocale, string } from "yup";
import { en } from "yup-locales";
import { _ROUTES } from "../../../utils/_routes_constants";
import {
  _ACTIONS,
  _COLORS,
  _CRUD,
  _HTTP,
  _MESSAGES,
  _SWAL_ICONS,
} from "../../../utils/constants";
import { useFormik } from "formik";
import { RequestHelper } from "../../../utils/requestHelper";
import { getMuiTableConfig } from "../../../utils/MuiTableUtils/muiTableBuilder";
import { useMaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import BasicModal from "../../helpers/BasicModal";
import BusinessIcon from "@mui/icons-material/Business";
import ActivitiesListColumns from "../../../utils/MuiTableUtils/ColumnBuilders/ActivitiesListColumns";
import { BasicFormikForm } from "../../form/BasicFormikForm";
import { BasicListContext } from "../../../contexts/BasicListContext";
import { MuiTableComponent } from "../../helpers/MuiTableComponent";
import { createToast } from "../../../utils/toast";

export const ActivitiesList = ({
  editData,
  setEditData,
  showModal,
  setShowModal,
}) => {
  const { open } = useContext(GlobalContext);
  const { user } = useContext(UserContext);
  const v = object({
    name: string().required().label("Name"),
    code: string().required().label("Code"),
    codeNumber: string().required().label("Code Number"),
    list: string().label("Knowned name").nullable().notRequired(),
    active: boolean().required().label("Active"),

  });

  const rq = new RequestHelper();

  setLocale(en);

  const formik = useFormik({
    initialValues: {
      name: "",
      code: "",
      codeNumber: "",
      list: "",
      active: true,
    },
    onSubmit: (values) => {
      const methode = editData ? _ACTIONS.PATCH : _ACTIONS.POST;
      const url = _ROUTES.ACTIVITIES + (editData ? `/${editData.id}` : "");
      const activity = {
        name: values.name,
        code: values.code,
        codeNumber: values.codeNumber,
        list: values.list,
        active: values.active,
      };

      rq.doRequest(methode, url, activity)
        .then((res) => {
          if (res.status === _HTTP.created || res.status === _HTTP.ok) {
            setShowModal(false);
            setEditData(null);
            setRefresh((prev) => {
              return prev + 1;
            });
          }
        })
        .catch((err) => {
          createToast(_SWAL_ICONS.error, _MESSAGES.error);
        });
    },
    validationSchema: v,
  });

  const {
    rowCount,
    data,
    isLoaded,
    isError,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    globalFilter,
    setGlobalFilter,
    sorting,
    setSorting,
    isLoading,
    setRefresh,
  } = useContext(BasicListContext);

  // Get the table configuration
  const c = getMuiTableConfig(
    // Params
    { enableColumnFilters: true, enableExpanding: true },
    // States & setStates (from context) Have to be the same as this
    {
      rowCount,
      isLoaded,
      isError,
      pagination,
      setPagination,
      columnFilters,
      setColumnFilters,
      globalFilter,
      setGlobalFilter,
      sorting,
      setSorting,
      isLoading,
    }
  );

  const columns = ActivitiesListColumns({
    setEditData,
    setShowModal,
    user,
    setRefresh,
  });

  const table = useMaterialReactTable({
    columns: columns,
    data: data,
    ...c,
    enableColumnResizing: false,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    initialState: {
      density: "compact",
    },
  });

  useEffect(() => {
    if (editData) {
      formik.setValues({
        name: editData.name,
        code: editData.code,
        codeNumber: editData.codeNumber,
        list: editData.list,
        active: editData.active,
      });
    } else {
      formik.resetForm();
    }
  }, [editData]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: open ? window.innerWidth - 340 : window.innerWidth - 64,
          borderRadius: "1px",
          boxShadow: `0px 0px 2px ${_COLORS.grey} `,
          overflowX: "auto",
        }}>
        {/* Table Component is here */}
        <MuiTableComponent route={_ROUTES.ACTIVITIES} table={table} />
      </Box>
      {/* Modal  */}
      <BasicModal
        showModal={showModal}
        setShowModal={setShowModal}
        title={editData ? _CRUD.update : _CRUD.create + " Activity"}
        content={
          <BasicFormikForm
            formik={formik}
            setEditData={setEditData}
            setShowModal={setShowModal}
            validations={v}
          />
        }
        icon={<BusinessIcon />}
        width={"500"}
      />
    </>
  );
};

export default ActivitiesList;
